import { Component, Input, OnInit } from '@angular/core';
import { CPPOrderSplitDetails } from './../../../../models/CPP/CPPOrderSummaryVM';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { CommonService } from '../../../../services/common/common.service';
import { MasterConstants } from '../../../../common/constants/master-constants';
@Component({
  selector: 'app-cpp-grid-view',
  templateUrl: './cpp-grid-view.component.html',
  styleUrls: ['./cpp-grid-view.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
    trigger('fadeInOut', [
      transition(':enter', [   // :enter is alias to 'void => *'
        style({ opacity: 0 }),
        animate(400, style({ height: '0px', opacity: 1 }))
      ]),
      transition(':leave', [   // :leave is alias to '* => void'
        animate(400, style({ height: '0px', opacity: 0 }))
      ])
    ])
  ]
})
export class CppGridViewComponent implements OnInit {
  gridDataList: any;
  itemList = new Array();
  plAccess = false;
  headerCompany: any;
  @Input()
  set gridData(val: CPPOrderSplitDetails) {
    this.gridDataList = val.productDetail.map((item, index) => ({ ...item, rowIndex: index }));
    console.log(this.gridDataList);
  }
  get gridData(): CPPOrderSplitDetails {
    return this.gridDataList;
  }
  displayedColumns: string[] = ['product', 'flashmsg', 'detail', 'quantity', 'orderUOM', 'totalGallons'];
  displayedFooterColumns: string[] = this.displayedColumns;
  @Input() itemSplitIndex: number;
  @Input() itemSplitId: number;
  constructor(private commonService: CommonService) { }

  ngOnInit() {
    this.plAccess = this.commonService.checkUserRoleAccessTypeForMenu(null, MasterConstants.FUNCTION_CODE.CROP_PROTECTION_PRODUCT_PRICE_LIST);
  }

  // Total price of all the items in the grid displayed
  getTotalPrice() {
    let totalPrice = 0;
    this.gridDataList.forEach(x => {
      totalPrice += x.totalPrice;
    });
    return totalPrice;
  }

  // Show or Hide Product detail
  showProductDetails(item) {
    if (item.lineStatus == 'CANCELLED') {
      return;
    }
    item.isDetailDisplayed = !item.isDetailDisplayed;
  }
}
